export default {
    data () {
        return {
            selectedCity: this.city ? this.city : 'Hela landet',
        }
    },
    methods: {
        updateCity () {
            if (this.selectedCity === 'Hela landet') {
                this.$store.dispatch('setCity', null);
            } else {
                this.$store.dispatch('setCity', this.selectedCity);
            }
        },
    }
}
